import { render } from "./Objectifs.vue?vue&type=template&id=4e75dde8"
import script from "./Objectifs.vue?vue&type=script&lang=js"
export * from "./Objectifs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__